import { createContext, useContext } from 'react';
import type { HeaderContextProps } from './interfaces';

export const HeaderContext = createContext({} as HeaderContextProps);

/**
 * Reads the integrations and controls provided by the nearest Commerce Header.
 *
 * ---
 * 🧠 **Context**
 *
 * - Must be called inside the existing {@link HeaderContext} provider.
 * - Context groups share one native React subscription; selecting a group does not isolate renders.
 *
 * ---
 * @example
 * ```ts
 * const { categories, pharmacy } = useHeader();
 * const openCategories = () => categories.setShowCategories(true);
 * const selectedPharmacyId = pharmacy.posStore.selectedPos?.id;
 * ```
 *
 * ---
 * @function useHeader
 * @returns {HeaderContextProps} Current shared Header integrations and controls.
 */
export function useHeader() {
	return useContext(HeaderContext);
}
